import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Transition } from '@headlessui/react'

import * as S from './CommerceBoxAnchorLink.styles'
import * as T from '../CommerceBox.types'

const CommerceBoxAnchorLink = ({
  productType,
  CTAButtonRef,
  scrollTargetRef,
  icon
}: T.CommerceBoxAnchorLink) => {
  const [yPosition, setYPosition] = useState(-1)
  const [showAnchorLink, setShowAnchorLink] = useState(false)
  const { formatMessage } = useIntl()

  const updateElemPos = () => {
    const rect = CTAButtonRef?.current?.getBoundingClientRect()
    const elemPos = Math.round(
      rect?.bottom || 0 + CTAButtonRef?.current?.innerHeight
    )

    setYPosition(elemPos)
  }

  useEffect(() => {
    const handleScroll = () => {
      //forcing position to minimum 0 to avoid Safari bounce effect
      const position = Math.max(window.scrollY, 0)

      if (yPosition >= position) {
        setShowAnchorLink(false)
      } else if (yPosition < position) {
        setShowAnchorLink(true)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [yPosition])

  useEffect(() => {
    if (CTAButtonRef?.current) {
      updateElemPos()
    }
  }, [CTAButtonRef?.current])

  const hadnleOnClick = () => {
    if (scrollTargetRef?.current) {
      const scrollOptions = {
        behavior: 'smooth'
      }

      setShowAnchorLink(false)
      scrollTargetRef.current.scrollIntoView(scrollOptions)
    }
  }

  const getTranslatedAnchorText = (productType: string): string => {
    switch (productType) {
      case 'machine':
        return formatMessage({
          id: 'add_to_cart_modal.type.machine',
          defaultMessage: 'Buy machine'
        })
      case 'accessories':
        return formatMessage({
          id: 'add_to_cart_modal.type.accessories',
          defaultMessage: 'Buy accessory'
        })
      case 'coffee':
        return formatMessage({
          id: 'add_to_cart_modal.type.coffee',
          defaultMessage: 'Buy coffee'
        })
      case 'tea':
        return formatMessage({
          id: 'add_to_cart_modal.type.tea',
          defaultMessage: 'Buy tea'
        })
      default:
        return formatMessage({
          id: 'add_to_cart_modal.type.generic',
          defaultMessage: 'Buy product'
        })
    }
  }

  return (
    <Transition
      appear={true}
      show={showAnchorLink}
      enter='transition-opacity duration-500'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='transition-opacity duration-500'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'
    >
      <div className={S.AnchorLinkWrapper} onClick={hadnleOnClick}>
        {icon || <></>}
        <span className={S.AnchorLinkText}>
          {getTranslatedAnchorText(productType)}
        </span>
      </div>
    </Transition>
  )
}

export default CommerceBoxAnchorLink
